export default class treeCollapser {

    constructor() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        this.header = document.querySelector('.collapser-tree');
        if (this.header === null) return;

        this.treeCollapsers = document.querySelectorAll('.js-tree-collapser');
        Array.prototype.forEach.call(this.treeCollapsers, (treeCollapser) =>
            treeCollapser.addEventListener("click", this.toggleCollapser.bind(this))
        );
    }

    toggleCollapser(event) {
        event.preventDefault();
        const el = event.target.nextElementSibling;

        event.preventDefault();

        if (!el.classList.contains('js-tree-collapser-ul-active')) {
            // CLOSE OTHERS

            this.old_active = document.querySelectorAll('.js-tree-collapser-active');

            if( this.old_active.length != 0){

                document.querySelectorAll('.js-tree-collapser-ul-active')[0].classList.remove('js-tree-collapser-ul-active');
                this.old_active[0].classList.remove('js-tree-collapser-active');

            }
            event.target.classList.add('js-tree-collapser-active');
            el.classList.add('js-tree-collapser-ul-active');
            el.style.height = 'auto';

            var height = (el.clientHeight + 16) + 'px';

            el.style.height = '0px';

            setTimeout(function () {

                el.style.height = height;
            }, 0);

        } else {

            el.style.height = '0px';

            el.addEventListener('transitionend', function () {
                el.classList.remove('js-tree-collapser-ul-active');
                event.target.classList.remove('js-tree-collapser-active');
            }, {
                once: true
            });

        }

    }

}
